// API function to fetch a specific substore's details
// Expected response from backend should include:
// {
//   id: number,              // Substore ID
//   name: string,            // Substore name
//   address: string,         // Physical address
//   join_code: string,       // Code for employees to join
//   working_time_start: string, // Format: "HH:MM" (24-hour)
//   working_time_end: string,   // Format: "HH:MM" (24-hour)
//   num_shifts: number,      // Number of shifts
//   num_employees: number,   // Number of employees (optional, can calculate on frontend)
//   store_manager: string,   // Name of manager (optional)
//   phone: string,           // Contact phone (optional)
//   email: string            // Contact email (optional)
// }
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const fetchSubstoreDetails = async (substoreId) => {
  const token = localStorage.getItem('token');
  const res = await fetch(`${BASE_URL}/owner/substore/${substoreId}/`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { 'Authorization': `Token ${token}` } : {})
    },
    credentials: 'include'
  });
  
  if (!res.ok) {
    throw new Error(`Failed to fetch substore details: ${res.status}`);
  }
  
  return await res.json();
};
